import React from 'react'
import VisitorLookingForCards from './VisitorLookingForCard'
import { LookingForListingWrapper } from '../../lookingForListing/styled'
import { Box } from '../../../../../components/styled/Elements'


const VisitorLookingForList = ({showAll, setShowAll, listing, user}) => {
  return (
    <LookingForListingWrapper>
        
        <Box className='w-100'>
            <VisitorLookingForCards showAll={showAll} setShowAll={setShowAll} listings={listing} user={user} />
        </Box>
    </LookingForListingWrapper>
  )
}

export default VisitorLookingForList


